export default "__VITE_ASSET__CUG5bX0X__"